const ACTION_TAG_PATTERN = /<\/?action_(\d+)>/g;

const coerceInt = (value) => {
  if (value === null || value === undefined || value === "" || value === true) {
    return null;
  }

  const parsed = Number(value);
  if (!Number.isInteger(parsed)) {
    return null;
  }

  return parsed;
};

const getMessageTextBlocks = (content) => {
  if (typeof content === "string") {
    return content ? [content] : [];
  }

  if (!Array.isArray(content)) {
    return [];
  }

  return content.flatMap((item) => {
    if (typeof item === "string") {
      return item ? [item] : [];
    }
    if (!item || typeof item !== "object") {
      return [];
    }
    if (typeof item.text === "string" && item.text) {
      return [item.text];
    }
    if (typeof item.content === "string" && item.content) {
      return [item.content];
    }
    return [];
  });
};

export const extractCompletedActionIdsFromHistory = (history) => {
  if (!Array.isArray(history)) {
    return [];
  }

  const actionIds = [];
  let lastSeenActionId = null;

  history.forEach((message) => {
    if (!message || typeof message !== "object" || message.role !== "assistant") {
      return;
    }

    getMessageTextBlocks(message.content).forEach((text) => {
      for (const match of text.matchAll(ACTION_TAG_PATTERN)) {
        const actionId = Number(match[1]);
        if (!Number.isInteger(actionId) || actionId === lastSeenActionId) {
          continue;
        }
        actionIds.push(actionId);
        lastSeenActionId = actionId;
      }
    });
  });

  return actionIds;
};

const buildSlideActionMap = (slide) => {
  if (!slide?.slide_data) {
    return {};
  }

  let slideData;
  try {
    slideData =
      typeof slide.slide_data === "string"
        ? JSON.parse(slide.slide_data)
        : slide.slide_data;
  } catch {
    return {};
  }

  const actions = Array.isArray(slideData?.actions) ? slideData.actions : [];
  const actionMap = {};

  actions.forEach((actionWrapper, index) => {
    const action =
      actionWrapper && typeof actionWrapper === "object"
        ? actionWrapper.action || actionWrapper
        : actionWrapper;
    if (!action || typeof action !== "object") {
      return;
    }

    actionMap[index] = action;
    const actionId = coerceInt(action.id);
    if (actionId !== null) {
      actionMap[actionId] = action;
    }
  });

  return actionMap;
};

export const deriveSafeResumeProgression = ({ history, slide }) => {
  const completedActionIds = extractCompletedActionIdsFromHistory(history);
  if (completedActionIds.length === 0) {
    return null;
  }

  const actionMap = buildSlideActionMap(slide);
  let lastCompletedFragmentIndex = null;

  completedActionIds.forEach((actionId) => {
    const action = actionMap[actionId];
    if (!action || !Array.isArray(action.fragment_ids)) {
      return;
    }

    const normalizedFragmentIds = action.fragment_ids
      .map((fragmentId) => coerceInt(fragmentId))
      .filter((fragmentId) => fragmentId !== null && fragmentId >= 0);

    if (normalizedFragmentIds.length > 0) {
      lastCompletedFragmentIndex =
        normalizedFragmentIds[normalizedFragmentIds.length - 1];
    }
  });

  return {
    lastCompletedActionId: completedActionIds[completedActionIds.length - 1],
    lastCompletedFragmentIndex,
  };
};
